import React from 'react'

const NoPage = () => {
  return (
    <div className='page'>
      <h1>
      Page doesnt exist
      </h1>
    </div>
  )
}

export default NoPage